import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    data: null,
  },
  mutations: {
    GET_DATA(state, data) {
      state.data = data;
    },
  },
  actions: {
    getContent({ commit }) {
      const loadContent =
        process.env.NODE_ENV === "production"
          ? "/dms+/data/data.json"
          : "http://geindustrial.com.ar/dms+/data/data.json";

      axios
        .get(loadContent)
        .then((resp) => {
          commit("GET_DATA", resp.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
  },
  modules: {},
});
